import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../rootReducer';

interface ViewConfig {
  lang: 'en' | 'ja' | null;
}

const initialState: ViewConfig = {
  lang: 'en',
};

const viewConfigSlice = createSlice({
  name: 'viewConfig',
  initialState,
  reducers: {
    updateLang(state, action: PayloadAction<{lang: ViewConfig['lang']}>) {
      const { lang } = action.payload;
      state.lang = lang;
    },
  },
});

export const {
  updateLang,
} = viewConfigSlice.actions;

export default viewConfigSlice.reducer;

export const selectLang = (state: RootState) => {
  const { lang } = state.viewConfig;
  return lang;
};
